import React from "react";
import BsyAlertMenu from "../../BsyAlertMenu";
import BsyGroupList from "../../BsyGroupList";
import BsyAlert from "../../BsyAlert";

import "./index.css";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsySLoading from "../../BsySLoading";

export default class BsyDashboardDesignAuth extends React.Component {
  static defaultProps = {
    designType: "company",
    isDraggable: true,
    isResizable: true,
    rowHeight: 18, //(document.documentElement.clientWidth - 250) / 60 - 10,
    onLayoutChange: function () {},
    cols: 60,
  };

  constructor(props) {
    super(props);
    this.state = {
      designList: [],
      group_id: props.selectDesignId,
      designMap: {},
    };
    this.designAuthRef = React.createRef();
  }

  componentDidMount() {
    this._getDesignList();
  }

  _getDesignList = () => {
    React.axios("/dashboard/config_dash/list").then((res) => {
      let designMap = {};
      let selectId = this.state.group_id;
      res.data.list.map((res1, key) => {
        designMap[res1.id] = res1;
      });
      this.setState({ designList: res.data.list, designMap }, () => {
        const _this = this;
        let opt = {
          renderEl: this.designAuthRef.current,
          value: designMap[selectId].auth,
          jobTitleEnable: !0,
          deptChildEnable: !0,
          hasDock: false,
          msg: React.language("member.add"),
          canClick: designMap[selectId].editEnable,
          managerPermissionEnable: !0,
          publicPermissionEnable: !0,
          onStopEdit: function (a) {
            React.axios("/dashboard/config_dash/auth", {
              id: selectId,
              auth: a,
            }).then((res) => {
              let designMap = {};
              res.data.list.map((res1, key) => {
                designMap[res1.id] = res1;
              });
              _this.setState({ designList: res.data.list, designMap });
            });
          },
        };
        new window.FX.MemberSelectPane(opt);
      });
    });
  };

  groupNodeClick = (id) => {
    const { designMap, group_id } = this.state;
    if (id === group_id) {
      return;
    }
    this.setState({ group_id: id }, () => {
      const _this = this;
      let opt = {
        renderEl: this.designAuthRef.current,
        value: designMap[id].auth,
        jobTitleEnable: !0,
        deptChildEnable: !0,
        hasDock: false,
        canClick: designMap[id].editEnable,
        msg: React.language("member.add"),
        managerPermissionEnable: !0,
        publicPermissionEnable: !0,
        onStopEdit: function (a) {
          React.axios("/dashboard/config_dash/auth", { id: id, auth: a }).then(
            (res) => {
              let designMap = {};
              res.data.list.map((res1) => {
                designMap[res1.id] = res1;
              });
              _this.setState({ designList: res.data.list, designMap });
            }
          );
        },
      };
      new window.FX.MemberSelectPane(opt);
    });
  };

  eventCustMent = (type, node) => {
    const FX = window.FX;
    const $ = window.$;
    switch (type) {
      case "del": {
        const _this = this;
        let n = $(
            '<div class="app-remove-confirm" style="marginTop: 20px;padding-left: 44px"/>'
          ),
          a = $('<div class="app-input-name"/>').appendTo(n);
        function e(e) {
          s &&
            s.okBtn &&
            (e === node.name ? s.okBtn.setOnClick(!0) : s.okBtn.setOnClick(!1));
        }
        new FX.TextEditor({
          renderEl: $('<div class="input-widget"/>').appendTo(a),
          waterMark: React.language("create.dashboard.design.tip"),
          width: "100%",
          onAfterEdit: function () {
            e(this.getValue());
          },
          onStopEdit: function () {
            e(this.getValue());
          },
        });
        let s = FX.Msg.alert({
          title: React.language("dashboard.design.delete.title", {
            name: node.name,
          }),
          msg: React.language("dashboard.design.delete.tip"),
          content: n,
          type: "swarning",
          enable4Ok: !1,
          onOk: function () {
 
            let layerRef = null;
            BsyMaskLayer({
              customCls: "hasBackground",
              onContentCreate: (ref) => {
                layerRef = ref;
                return (
                  <div>
                    <BsySLoading />
                  </div>
                );
              },
            });
            React.axios("/dashboard/config_dash/delete", { id: node.id })
              .then((res) => {
                let designMap = {};
                res.data.list.map((res1) => {
                  designMap[res1.id] = res1;
                });
                _this.setState({ designList: res.data.list, designMap });
                _this.props.updataList &&
                  _this.props.updataList(res.data.list, res.data.list[0].id);
                _this.groupNodeClick(res.data.list[0].id);
                layerRef && layerRef.close();
              })
              .catch(() => {
                layerRef && layerRef.close();
              });
          },
          onCancel: function () {},
        });
        break;
      }
      case "rename": {
        BsyAlert({
          title: React.language("name.update"),
          onInputValidate: () => {
            return true;
          },
          type: "noIconInput",
          maxLength: 26,
          text4Ok: React.language("ok"),
          OkType: "blue",
          closeBtn: true,
          value: node.name,
          placeholder: React.language("create.dashboard.design.tip"),
          text4Cancel: React.language("cancel"),
          ok: (value) => {
            if (node.name === value) {
              return !0;
            }
            if (node.name === "") {
              tipAlert({
                type: "warning",
                msg: React.language("design.warning.msg"),
              });
              return !1;
            }
            if (value.length > 26) {
              tipAlert({
                type: "warning",
                msg: React.language("design.warning.msg1"),
              });
              return !1;
            }
            React.axios("/dashboard/config_dash/rename", {
              id: node.id,
              name: value,
            }).then((res) => {
              let designMap = {};
              res.data.list.map((res1) => {
                designMap[res1.id] = res1;
              });
              this.setState({ designList: res.data.list, designMap });
              this.props.updataList && this.props.updataList(res.data.list);
            });
          },
        });
        break;
      }
      case "copy": {
        React.axios("/dashboard/config_dash/copy", { id: node.id }).then(
          (res) => {
            if (res.data.errcode === 1) {
              tipAlert({
                type: "warning",
                msg: res.data.errmessage,
              });
              return;
            }
            let designMap = {};
            res.data.list.map((res1) => {
              designMap[res1.id] = res1;
            });
            this.setState({ designList: res.data.list, designMap });
            this.props.updataList && this.props.updataList(res.data.list);
          }
        );
        break;
      }
      case "set": {
        this.props.eventCustMent && this.props.eventCustMent(node, "set");
        break;
      }
      default: {
      }
    }
  };

  groupMoreOperate = (e, node) => {
    let menu = [
      {
        text: React.language("set.dashboard.design"),
        colorType: "",
        click: () => {
          this.eventCustMent("set", node);
        },
      },
      {
        text: React.language("name.update"),
        colorType: "",
        click: () => {
          this.eventCustMent("rename", node);
        },
      },
      {
        text: React.language("copy"),
        colorType: "",
        click: () => {
          this.eventCustMent("copy", node);
        },
      },
      {
        text: React.language("delete"),
        colorType: "red",
        click: () => {
          this.eventCustMent("del", node);
        },
      },
    ];
    if (!node.editEnable) {
      menu = [
        {
          text: React.language("set.dashboard.design"),
          colorType: "",
          click: () => {
            this.eventCustMent("set", node);
          },
        },
        {
          text: React.language("name.update"),
          colorType: "",
          click: () => {
            this.eventCustMent("rename", node);
          },
        },
      ];
    }
    BsyAlertMenu({
      item: menu,
      // renderEl: e.currentTarget,
      width: 140,
      target: e.currentTarget,
    });
  };

  openCreateDesign = () => {
    BsyAlert({
      title: React.language("create.dashboard.design"),
      onInputValidate: () => {
        return true;
      },
      closeBtn: true,
      maxLength: 26,
      type: "noIconInput",
      text4Ok: React.language("ok"),
      OkType: "blue",
      placeholder: React.language("create.dashboard.design.tip"),
      text4Cancel: React.language("cancel"),
      ok: (value) => {
        if (value === "") {
          tipAlert({
            type: "warning",
            msg: React.language("design.warning.msg"),
          });
          return !1;
        }
        if (value.length > 26) {
          tipAlert({
            type: "warning",
            msg: React.language("design.warning.msg1"),
          });
          return !1;
        }
        React.axios("/dashboard/config_dash/create", { name: value }).then(
          (res) => {
            if (res.data.errcode === 1) {
              tipAlert({
                type: "warning",
                msg: res.data.errmessage,
              });
              return;
            }
            let designMap = {};
            res.data.list.map((res1) => {
              designMap[res1.id] = res1;
            });
            this.setState({ designList: res.data.list, designMap });
            this.groupNodeClick(res.data.id);
            this.props.updataList &&
              this.props.updataList(res.data.list, res.data.id);
          }
        );
      },
    });
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    // const first = result.splice(0, 1);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  groupNodeMove = (attr) => {
    const customGroup = [...this.state.designList];
    const groupList = this.reorder(
      customGroup,
      attr.source.index,
      attr.destination.index
    );
    const outsiders = [...groupList];
    // this.props.outsiders = groupList;

    let data = {
      id: attr.draggableId, //被移动的成员
      prev:
        attr.destination.index === 0
          ? ""
          : outsiders[attr.destination.index - 1].id,
    };

    this.setState(
      {
        designList: outsiders,
      },
      () => {
        React.axios("/dashboard/config_dash/sort", data)
          .then((res) => {
            let designMap = {};
            res.data.list.map((res1) => {
              designMap[res1.id] = res1;
            });
            this.setState({ designList: res.data.list, designMap });
          })
          .catch((res) => {});
      }
    );
  };

  render() {
    const { designList, group_id, designMap } = this.state;
    const customList = [];
    const defList = [];
    designList &&
      designList.map((res) => {
        if (res.editEnable) {
          customList.push(res);
        } else {
          res.afterText = React.language("default");
          res.afterTextColor = "#4D609F";
          customList.push(res);
        }
        return !1;
      });
    return (
      <div className="BsyDashboardDesignAuth">
        <div className="dashboardDesignAuthContent">
          <div className="design-auth-left">
            <div className="design-auth-title">
              <div className="auth-left">
                <div className="auth-title">
                  <span>1.{React.language("select.dashboard.design")}</span>
                </div>
              </div>
              <div className="auth-right">
                <div className="auth-create" onClick={this.openCreateDesign}>
                  <i className="icon-add"></i>
                </div>
              </div>
            </div>
            <BsyGroupList
              groups={customList}
              selectGroup={group_id}
              hasCustom={false}
              nodeClick={(node) => this.groupNodeClick(node.id)}
              nodeSort={(attr) => this.groupNodeMove(attr)}
              keyid={"id"}
              nodeMoreOperate={(e, node) => this.groupMoreOperate(e, node)}
              hasDeletedList={false}
              sortable={true}
              hasMenu={true}
              // splitMenuIcon={'icon-bsy-iconputongguanlizu'}
              splitMenuName={React.language("manager.normal")}
            />
          </div>
          <div className="design-auth-right">
            <div className="design-auth-title">
              <div className="auth-left">
                <div className="auth-title">
                  <span>2.{React.language("set.dashboard.design.auth")}</span>
                </div>
                <div className="auth-msg">
                  <span>{React.language("set.dashboard.design.auth.msg")}</span>
                </div>
              </div>
              <div className="auth-right"></div>
            </div>
            <div className="design-auth-content">
              <div className="auth-item">
                <div className="item-desc">
                  <div className="desc-title">
                    <span>{React.language("dashboard.design.auth.title")}</span>
                  </div>
                  <div className="desc-msg">
                    <span>{React.language("dashboard.design.auth.msg")}</span>
                  </div>
                </div>
                <div className="userAuthCont" ref={this.designAuthRef}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
